import { render, staticRenderFns } from "./StockIndexNew.vue?vue&type=template&id=a4161aca&"
import script from "./StockIndexNew.vue?vue&type=script&lang=ts&"
export * from "./StockIndexNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports